module.exports = __webpack_public_path__ + "images/emoji/goberserk.7eb1342916d725e1c970.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/goberserk.png
// module id = IoYY
// module chunks = 2